var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 77,
    viewBox: "0 0 82 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5199_6367)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4414 33.0825L69.4429 33.0836C70.2239 33.6284 70.7338 34.5336 70.7338 35.5582C70.7338 37.2244 69.3835 38.5747 67.7173 38.5747C67.7138 38.5747 67.7103 38.5747 67.7067 38.5747H64.3118V62.7869C64.3118 64.4531 62.9616 65.8033 61.2954 65.8033H20.4283C18.7621 65.8033 17.4119 64.4531 17.4119 62.7869V38.5747H14.0167C12.7365 38.5747 11.5955 37.7666 11.171 36.5587C10.7463 35.3506 11.1302 34.0067 12.1288 33.2057L38.9743 11.6635C40.0768 10.7788 41.6465 10.7788 42.7496 11.6635L69.4414 33.0825Z",
    fill: "#D5D4D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4485 34.4288C68.8181 34.6686 69.0619 35.0849 69.0619 35.5583C69.0619 36.3016 68.4596 36.9038 67.7163 36.9038C67.7131 36.9037 67.7094 36.9038 67.7057 36.9038H62.6399V62.7869C62.6399 63.5302 62.0376 64.1325 61.2943 64.1325H20.4273C19.684 64.1325 19.0817 63.5302 19.0817 62.7869V36.9038H14.0157C13.4446 36.9038 12.9356 36.5433 12.7462 36.0045C12.5567 35.4657 12.728 34.8662 13.1735 34.5088L40.0188 12.9668C40.5107 12.5722 41.2109 12.5722 41.703 12.9668L68.4485 34.4288Z",
    fill: "#EAE9EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8604 36.8534C42.402 34.3784 44.9712 32.6459 48.0543 32.6459C52.4219 32.6459 55.7619 35.8633 55.7619 40.0708C55.7619 48.2382 51.1373 49.4758 40.8604 58.8806C30.5836 49.4758 25.959 48.2382 25.959 40.0708C25.959 35.8633 29.299 32.6459 33.6666 32.6459C36.7496 32.6459 39.3189 34.3784 40.8604 36.8534Z",
    fill: "#D5D4D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9652 40.6274C41.8194 39.2035 43.2433 38.2069 44.9518 38.2069C47.3725 38.2069 49.2233 40.0579 49.2233 42.4784C49.2233 47.177 46.6605 47.8889 40.9652 53.2995C35.2698 47.8889 32.707 47.177 32.707 42.4784C32.707 40.0579 34.5579 38.2069 36.9785 38.2069C38.687 38.2069 40.1109 39.2035 40.9652 40.6274Z",
    fill: "#EAE9EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5199_6367",
    x: 0.557035,
    y: 0.974754,
    width: 80.6203,
    height: 75.6892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.417719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22148
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5199_6367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5199_6367",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataHome);
export default __webpack_public_path__ + "static/media/no-data-home.ecd26abf92de186a901db6caad606fc5.svg";
export { ForwardRef as ReactComponent };